import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    settingsHeading: {
      padding: '24px 40px',
      justifyContent: 'space-between',
      background: 'transparent',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        gap: '20px'
      },
      [theme.breakpoints.only('sm')]: {
        padding: '18px 20px 18px 20px'
      },
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '18px 0px 18px 0px',
        height: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        height: '100px'
      }
    },
    settingsHeaderText: {
      lineHeight: '1',
      fontSize: '40px',
      fontFamily: 'Poppins, sans-serif',
      letterSpacing: 'normal',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: '36px'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '32px'
      },
      [theme.breakpoints.only('md')]: {
        fontSize: '36px'
      }
    },
    errorOverlayHeader: {
      textAlign: 'center',
      fontSize: '48px',
      margin: '0px 10px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('sm')]: {
        fontSize: '30px'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px'
      }
    },
    kioskEventRefreshDescription: {
      width: '600px',
      flex: 'none',
      background: 'transparent',
      [theme.breakpoints.only('sm')]: {
        width: '100%',
        padding: '0px 20px 0px 0px'
      },
      [theme.breakpoints.only('xs')]: {
        width: '345px',
        padding: '0px 10px 0px 10px'
      }
    },
    kioskRefreshDescriptionText: {
      textAlign: 'center',
      fontSize: '24px',
      margin: '0px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    salesReportButton: {
      margin: '32px 0 0 20px',
      width: '145px'
    },
    lookupText: {
      textAlign: 'center',
      fontSize: '18px',
      margin: '0px 60px 0px 30px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    creationText: {
      textAlign: 'center',
      fontSize: '18px',
      margin: '0px 50px 0px 30px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    surveyPageText: {
      padding: '24px 0px',
      textAlign: 'center',
      fontSize: '24px',
      marginRight: '100px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    donationOverlay: {
      padding: '24px 0px',
      textAlign: 'center',
      fontSize: '24px',
      marginRight: '30px',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    customerIdentification: {
      lineHeight: '1',
      fontSize: '24px',
      fontFamily: 'Poppins, sans-serif',
      letterSpacing: 'normal'
    }
  })
);
